import { render } from "./PatientListItem.vue?vue&type=template&id=3b319348&scoped=true&ts=true"
import script from "./PatientListItem.vue?vue&type=script&lang=ts"
export * from "./PatientListItem.vue?vue&type=script&lang=ts"

import "./PatientListItem.vue?vue&type=style&index=0&id=3b319348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b319348"]])

export default __exports__